export default __webpack_public_path__ + "static/image149-0ce3fd69e2e14d44cca57f9164bbd802.jpg";